function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { useLocation } from 'react-router-dom';
var HistoryManagerContext = /*#__PURE__*/React.createContext({
  getPageData: function getPageData() {
    //
  },
  setPageData: function setPageData() {
    //
  },
  setPageProps: function setPageProps() {
    //
  }
});
var initial = new Map();
export var HistoryManagerProvider = function HistoryManagerProvider(_ref) {
  var children = _ref.children;
  var store = React.useRef(initial);
  var location = useLocation();
  var value = React.useMemo(function () {
    return {
      getPageData: function getPageData() {
        return store.current.get(location.key);
      },
      setPageData: function setPageData(pageData) {
        return store.current.set(location.key, pageData);
      },
      setPageProps: function setPageProps(props) {
        var _store$current, _store$current2;
        return (_store$current = store.current) === null || _store$current === void 0 ? void 0 : _store$current.set(location.key, _objectSpread(_objectSpread({}, (_store$current2 = store.current) === null || _store$current2 === void 0 ? void 0 : _store$current2.get(location.key)), {}, {
          props: props
        }));
      }
    };
  }, [location.key]);
  return /*#__PURE__*/React.createElement(HistoryManagerContext.Provider, {
    value: value,
    children: children
  });
};
export function useHistoryManager() {
  return React.useContext(HistoryManagerContext);
}